import createIcon from '../../createIcon';

/**
 * @component @name LtePlusMobiledata
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMi41IDE0SDUuNVYxNkgwLjVWOEgyLjVWMTRaTTQuNSAxMEg2LjVWMTZIOC41VjEwSDEwLjVWOEg0LjVWMTBaTTExLjUgMTZIMTYuNVYxNEgxMy41VjEzSDE2LjVWMTFIMTMuNVYxMEgxNi41VjhIMTEuNVYxNlpNMjMuNSAxMUgyMS41VjlIMTkuNVYxMUgxNy41VjEzSDE5LjVWMTVIMjEuNVYxM0gyMy41VjExWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LtePlusMobiledata = createIcon('LtePlusMobiledata', [
  [
    'path',
    {
      d: 'M2.5 14H5.5V16H0.5V8H2.5V14ZM4.5 10H6.5V16H8.5V10H10.5V8H4.5V10ZM11.5 16H16.5V14H13.5V13H16.5V11H13.5V10H16.5V8H11.5V16ZM23.5 11H21.5V9H19.5V11H17.5V13H19.5V15H21.5V13H23.5V11Z',
      key: '101vk5',
    },
  ],
]);

export default LtePlusMobiledata;
